module.exports = __webpack_public_path__ + "static/media/iconSac.db8d4f4e.svg";